import { months } from "./months";

const getFormattedDate = (dateString: string) => {
  const date = new Date(dateString);
  return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
};
export default getFormattedDate;
